<template>
  <div class="contenido-contexto m-t-1-sm m-b-3-sm m-y-2-md">
    <h1 class="container text">Arribazón de sargazo a las costas mexicanas</h1>

    <div class="container text">
      <ul>
        <li>
          Las arribazones de sargazo en el Caribe mexicano son de dimensiones
          inusitadas y los estudios científicos sugieren que éstos podrían ser
          recurrentes.
        </li>
        <li>
          El sargazo acumulado en la playa se descompone produciendo ácido
          sulfhídrico que emite un intenso olor fétido y puede alcanzar niveles
          serios de toxicidad para los humanos. El sargazo está afectando
          severamente a ecosistemas, especies de alto valor biológico, la pesca
          y al turismo de playa.
        </li>
        <li>
          En México nos hemos enfocado en recolectar el sargazo en las playas
          pero debemos encaminarnos a la recolección en el mar por medio de
          métodos de detección y de alerta temprana.
        </li>
        <li>
          México tiene ante sí la oportunidad estratégica de apropiarse del
          sargazo como un recurso biótico nacional que, con el desarrollo de
          tecnologías, podría ser una fuente de biomasa para la producción de
          biogás, fertilizantes y mejoradores de suelos, entre otros. En México
          actualmente se cuenta con un consejo asesor honorario para analizar
          integralmente la proliferación del sargazo y definir una agenda
          científica, tecnológica y de innovación para su atención.
        </li>
        <li>
          Es fundamental la conformación de un consorcio de países de la región
          que busque el establecimiento de tratados internacionales para la
          regulación de la contaminación que llega a los mares.
        </li>
      </ul>

      <div class="imagen-con-referencia ocultar-vista-simplificada">
        <img src="@/assets/img/contexto/foto_UNAM.png" alt="" />
        <blockquote>
          Foto: Edgar Escalante Mancera, Unidad Académica Sistemas Arrecifales
          del ICML en Puerto Morelos, UNAM.
        </blockquote>
      </div>
    </div>

    <div class="container text m-t-1-sm m-b-1-sm m-y-1-md">
      <p>
        Las especies <i>Sargassum natans</i> y <i>Sargassum fluitans</i> habitan
        las capas superficiales del mar. Estas inmensas masas flotantes de algas
        cumplen funciones ecológicas importantes, pues ofrecen áreas de
        descanso, reproducción, alimentación y transporte para otras especies, y
        son base de las redes alimenticias en el mar.
      </p>
      <p>
        Al ser un organismo flotante, el sargazo se mueve a través del océano
        arrastrado por el viento y las corrientes marinas y ocasionalmente
        arriba de forma natural a las costas. Sin embargo, desde 2011 se ha
        observado un crecimiento masivo y sostenido de las poblaciones de estas
        especies en el Atlántico, hasta alcanzar una longitud de 8,850
        kilómetros en 2018 (aproximadamente la distancia que existe entre la
        CDMX y la Patagonia), formando al que se ha llamado el “Gran Cinturón de
        Sargazo” con una biomasa aproximada de 20 millones de toneladas; cifra
        equivalente a 10 veces el total de la pesca y la maricultura anual
        nacional. Es probable que el origen de este fenómeno sin precedentes
        esté vinculado con el cambio climático y otras alteraciones ambientales
        antropogénicas a escala global.
      </p>
      <p>
        El Gran Cinturón de Sargazo se origina en la costa de África occidental
        y es desplazado por corrientes marinas hacia América. Estas macroalgas
        encuentran condiciones favorables para su crecimiento por la
        precipitación de polvo proveniente del desierto del Sahara y la gran
        cantidad de nutrientes que encuentran a su paso hacia el caribe. En su
        camino, esta enorme masa cruza por la desembocadura del Amazonas y las
        inmensas masas flotantes de sargazo son arrastradas hacia el norte a
        través del Mar Caribe.
      </p>
      <p>
        Las arribazones de sargazo a las costas de México y otros países del
        Gran Caribe, es evidencia de un cambio ambiental global de dimensiones
        colosales que se ha convertido en una seria amenaza económica, social y
        ambiental para el país.
      </p>
      <p>
        La enorme cantidad de sargazo hacinado sobre las costas ejerce impactos
        severos sobre ecosistemas y especies de alto valor biológico. Ejemplo de
        ello son las alteraciones observadas sobre la 2ª barrera arrecifal más
        grande del mundo, el Sistema Arrecifal Mesoamericano, donde tanto el
        arrecife, como las praderas marinas se ven seriamente afectadas debido a
        que la capa de sargazo sobre la superficie del agua impide el paso de la
        luz, además de que su descomposición reduce la concentración de oxígeno
        disuelto en el agua.
      </p>
      <p>
        Por otra parte, el impacto al turismo de playa en toda la región
        caribeña es preocupante. Con la llegada masiva de sargazo, las playas
        pierden su componente escénico y con ello el valor de uso turístico. Por
        ello, los prestadores de servicios turísticos y la población local han
        reaccionado de diversas formas tratando de mitigar sus impactos.
      </p>
      <p>
        En México, los esfuerzos se han centrado principalmente en la
        recolección de la biomasa sobre las playas, principalmente en aquellas
        de importancia turística, pero no se han sentado las bases para
        enfrentar el problema a largo plazo. Por los impactos secundarios, la
        recolección de sargazo en playa es un escenario no deseable. En todo
        caso, los esfuerzos deben encaminarse en su recolección o desvío en el
        mar previo al arribazón y el inicio del proceso de descomposición en las
        playas.
      </p>
      <p>
        En ocasiones, el sargazo se ha recolectado y trasladado a zonas de menor
        importancia turística o tiraderos clandestinos, creando ambientes
        insalubres y afectaciones severas a los mantos freáticos debido al
        carácter poroso del suelo de la región. Por tanto, si los esfuerzos
        continúan centrados únicamente en la mitigación de la emergencia a corto
        plazo, difícilmente se alcanzará una solución eficaz para un fenómeno
        complejo y recurrente.
      </p>
      <p>
        Para que México pueda apropiarse del sargazo como un recurso biótico
        nacional, es indispensable dar un impulso decisivo hacia a la
        consolidación de una industria nacional para el aprovechamiento
        sustentable y regulado de este recurso. Por lo anterior, es preciso
        incentivar el desarrollo tecnológico hacia el uso local y regional, así
        como la generación de cadenas de valor.
      </p>
      <p>
        El sargazo podría ser utilizado para la producción de biogás,
        fertilizantes, mejoradores de suelos, alimentos, forrajes, materiales
        biodegradables, entre otros. No obstante, la investigación científica
        necesaria para definir tecnologías y rendimientos, así como para
        descartar diversos grados de contaminación por metales pesados o alguna
        otra sustancia que impida su uso, aún es incipiente. De cualquier forma,
        por razones de salud ambiental y salud pública, el Estado Mexicano debe
        garantizar la gestión adecuada del sargazo aun cuando no hubiere interés
        industrial para su transformación. Por ello, su rol como promotor de la
        investigación científica y tecnológica en busca de alternativas para el
        aprovechamiento de este recurso es incuestionable.
      </p>
      <p>
        La evidencia científica sugiere que los afloramientos masivos de sargazo
        se han convertido en la nueva norma y que el Gran Cinturón de Sargazo
        llegó para quedarse. La tendencia muestra arribazones estacionales en
        México, siendo la temporada más crítica entre los meses de mayo a
        septiembre. La implementación de un amplio programa de investigación
        interdisciplinaria de largo plazo es ineludible. Este enfoque debe
        acompañarse de acciones para la atención del problema en periodos
        críticos, sin cejar en los periodos intermedios, con el fin de continuar
        fortaleciendo las capacidades instaladas en el país en forma progresiva.
      </p>
      <p>
        En la atención a esta problemática, la colaboración internacional
        reviste una importancia incuestionable, pues se trata de un reto que
        traspasa fronteras. Es fundamental la conformación de un consorcio de
        países de la región que busque el establecimiento de tratados
        internacionales para el entendimiento del fenómeno, su aprovechamiento y
        la regulación de la contaminación que llega a los mares, ya que ésta
        pudiera incentivar el incremento masivo del sargazo. El gobierno federal
        tiene ante sí la oportunidad de impulsar la elaboración de una agenda de
        cooperación nacional e internacional que genere acuerdos multilaterales
        para la protección de los ecosistemas marinos, que puedan a su vez
        articularse con otros acuerdos existentes como el Convenio sobre
        Diversidad Biológica que opera bajo el Programa de las Naciones Unidas
        para el Medio Ambiente (PNUMA), entre otros.
      </p>
      <p>
        México posee la suficiente capacidad institucional, así como talento
        técnico, científico, industrial y de mercado para enfrentar esta
        emergencia a través de la generación de soluciones efectivas y
        perdurables. En 2019 se conformó un Consejo Asesor honorario para
        analizar integralmente esta situación y definir una agenda científica,
        tecnológica y de innovación para la atención de la proliferación del
        sargazo. Esta iniciativa busca acompañar y orientar las acciones del
        Gobierno Federal, con la intención de actuar con eficacia y prontitud,
        mediante una fina planeación.
      </p>
      <p>
        Es preciso reconocer que nos enfrentamos a un fenómeno intermitente, por
        lo que los periodos intercríticos deben ser aprovechados activamente
        para fortalecer y dar continuidad a las acciones coordinadas, en el
        entendido que es sólo cuestión de tiempo para la llegada de la siguiente
        arribazón.
      </p>

      <div class="imagen-con-referencia ocultar-vista-simplificada">
        <img src="@/assets/img/contexto/cobertura_promedio.jpg" alt="" />
        <blockquote>
          Cobertura promedio mensual de sargazo en el mar Caribe y en el Océano
          Atlántico central. (Wang et al., 2019)
        </blockquote>
      </div>
      <div class="imagen-con-referencia ocultar-vista-simplificada">
        <img src="@/assets/img/contexto/comparacion_anios.jpg" alt="" />
        <blockquote>
          Densidad de sargazo durante el mes de julio de los años 2013-2018.
          Colores cálidos representan mayor densidad y colores fríos menor
          densidad de sargazo. (Wang et al., 2019)
        </blockquote>
      </div>
    </div>

    <ReferenciasBibliograficas
      class="container text m-t-1-sm m-b-3-sm m-y-2-md"
      titulo="Referencias bibliográficas"
      :referencias="require('@/assets/data/referencias_contexto.json')"
    />

    <div class="container text m-t-1-sm m-b-3-sm m-y-2-md a11y-simplificada-block">
      <a href="https://docs.google.com/forms/d/e/1FAIpQLSdM2lwTbT7jA2Hz31cPtHrMvU3FWz62U7gBeFj99tVSIq-YAA/viewform">
        <b>Encuesta pública</b>
      </a>
    </div>
    
  </div>
</template>

<script>
import ReferenciasBibliograficas from "@/components/utiles/ReferenciasBibliograficas";

export default {
  components: {
    ReferenciasBibliograficas,
  },
};
</script>

<style lang="scss">
.contenido-contexto {
  h1.container.text {
    font-size: 34px;
    font-weight: 500;
  }
  ul > li::before {
    height: 6px;
    width: 6px;
  }
  .imagen-con-referencia {
    margin-bottom: 24px;
    img {
      width: 100%;
    }
    blockquote {
      margin: 0;
      font-size: 14px;
    }
  }
}
</style>
